import { select } from 'helpers/dom'

const selectors = {
  CAROUSEL_SWIPER_SELECTOR: '.js-carousel-swiper',
  CAROUSEL_SWIPER_PREV_SELECTOR: '.js-carousel-prev',
  CAROUSEL_SWIPER_NEXT_SELECTOR: '.js-carousel-next',
  PAGINATION_SELECTOR: '.js-carousel-pagination',
  SCROLL_BAR_SELECTOR: '.js-carousel-scrollbar'
}

class SwiperCarouselInstance {
  constructor(element, options, config, setRefCallback) {
    this.element = element
    this.setOptions(options || {}, config)
    this.initCarousel(setRefCallback)
    this.retried = false
  }

  setOptions(options, config) {
    const { navigation, pagination, scrollbar } = options || {}

    const navEl = {
      prevEl: select(selectors.CAROUSEL_SWIPER_PREV_SELECTOR, this.element),
      nextEl: select(selectors.CAROUSEL_SWIPER_NEXT_SELECTOR, this.element)
    }

    const paginationEl = select(selectors.PAGINATION_SELECTOR, this.element)

    const scrollbarEl = select(selectors.SCROLL_BAR_SELECTOR, this.element)

    let optionThumbnail = {}
    if (config.thumbnail) {
      const thumbnailEl = select(config.thumbnail)
      optionThumbnail = {
        thumbs: {
          swiper: thumbnailEl
        }
      }
    }

    this.options = {
      ...options,
      navigation: config.navigation && { ...navigation, ...navEl },
      pagination: config.pagination && { ...pagination, el: paginationEl },
      scrollbar: config.scrollbar && { ...scrollbar, el: scrollbarEl },
      ...optionThumbnail
    }
  }

  initCarousel(setRefCallback) {
    const swiperEl = select(selectors.CAROUSEL_SWIPER_SELECTOR, this.element)
    // Only guard against empty carousels that are not gallery thumbnails
    const isGalleryThumbnail = swiperEl?.classList?.contains('js-carousel-gallery-thumbnail')
    const slideCount = swiperEl?.querySelectorAll('swiper-slide')?.length || 0
    if (!isGalleryThumbnail && slideCount === 0) return

    // PERFORMANCE FIX: Wait for Swiper to be fully loaded before initializing
    // This prevents the flicker caused by the 1-second retry delay
    if (!swiperEl.initialize && !this.retried) {
      this.retried = true

      // Use requestAnimationFrame for smoother initialization
      const waitForSwiper = () => {
        if (swiperEl.initialize) {
          Object.assign(swiperEl, this.options)
          swiperEl.initialize()
          if (setRefCallback) {
            setRefCallback()
          }
        } else {
          // Shorter, non-blocking retry intervals
          requestAnimationFrame(waitForSwiper)
        }
      }

      waitForSwiper()
      return
    }

    Object.assign(swiperEl, this.options)
    if (swiperEl.initialize) {
      swiperEl.initialize()
      if (setRefCallback) {
        setRefCallback()
      }
    }
  }
}

export default SwiperCarouselInstance
